import { render } from "./subbase.vue?vue&type=template&id=e848db40&scoped=true"
import script from "./subbase.vue?vue&type=script&lang=js"
export * from "./subbase.vue?vue&type=script&lang=js"

import "./subbase.vue?vue&type=style&index=0&id=e848db40&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e848db40"]])

export default __exports__